import * as React from 'react';

const FilmMediaSmallSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.415 3.01c.2-.047.4.075.449.274l.75 3a.375.375 0 01-.28.456L7.394 9.75h13.232c.207 0 .375.168.375.375v10.5a.375.375 0 01-.375.375h-16.5a.375.375 0 01-.375-.375V10.178l-.739-2.962a.375.375 0 01.28-.456l.896-.209a.377.377 0 01.15-.035l3.54-.823a.377.377 0 01.075-.017L19.415 3.01zM4.288 7.298l-.457.106.567 2.272 2.704-.628-2.814-1.75zm3.848 1.51l-2.814-1.75 2.613-.609L10.75 8.2l-2.613.608zm6.26-1.457l-2.614.608L8.97 6.21l2.613-.608 2.814 1.75zM4.5 13.5h.75a.374.374 0 00.267-.111l2.9-2.889h2.688l-2.26 2.25h-.97a.375.375 0 000 .75H20.25v6.75H4.5V13.5zm5.408-.75h2.687l2.26-2.25h-2.688l-2.259 2.25zm6.437 0h-2.687l2.26-2.25h2.687l-2.26 2.25zm1.063 0h2.842V10.5h-.582l-2.26 2.25zm-12.908 0h.595l2.26-2.25H4.5v2.25zm8.115-7.389l2.614-.608 2.813 1.75-2.613.608-2.814-1.75zm6.46.902l-2.813-1.75 2.964-.69.568 2.273-.718.167zM6 15.375c0-.207.168-.375.375-.375h12a.375.375 0 010 .75h-12A.375.375 0 016 15.375zm.375 1.875a.375.375 0 000 .75h12a.375.375 0 000-.75h-12z"
            fill="#585163"
        />
    </svg>
);

FilmMediaSmallSvg.displayName = 'FilmMediaSmallSvg';
export default FilmMediaSmallSvg;
